import React from 'react'
import {connect} from 'react-redux'
import {withSiteData} from 'react-static'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';

import {updateOrder} from '../actions/orders'
import OrderForm from '../components/OrderForm'
import Spinner from '../components/Spinner'

class ShowOrderModal extends React.Component {
  constructor(props){
    super(props)
    this.state = {show: true}
  }

  close = () => this.setState({show: false})

  restoreUrl = () => {
    this.props.history.replace(this.props.backPath || '/orders')
  }

  handleSubmit = (values) => this.props.submit(values).then(this.close)

  render() {
    return(
      <Modal
        size='lg'
        isOpen={this.state.show}
        toggle={this.close}
        onClosed={this.restoreUrl}>
        <ModalHeader toggle={this.close}>Bearbeite Auftrag</ModalHeader>

        <OrderForm
          orders={this.props.orders}
          clients={this.props.clients}
          products={this.props.products}
          order={this.props.order}
          submit={this.handleSubmit}
          bodyComponent={({children}) =>
            <ModalBody>
              {this.props.isFetching ? <Spinner/> : children}
            </ModalBody>
          }
          buttonsComponent={({children}) =>
            <ModalFooter>
              {children}
              <Button color="secondary" onClick={this.close}>Abbrechen</Button>
            </ModalFooter>
          }/>
      </Modal>
    )
  }
}

export default connect(
  (state,ownProps) => {
    const order = state.orders.items.find(o => o.id===ownProps.match.params.id)
    return {
      order,
      orders: state.orders,
      isFetching: !order,
      clients: state.clients,
      products: state.products
    }
  },
  dispatch => ({
    submit: (payload) => dispatch(updateOrder(payload))
  })
)(withSiteData(ShowOrderModal))



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/ShowOrder.js